import React from 'react';

export default function CartItem({item, value}) {
  const { id, title, img, price, total, count } = item;
  const { increment, decrement, removeItem } = value;
  return (
    <div className="cartRow">
      <div className="cartCol">
        <img
          src={img}
          style={{ width: "5rem" }}
          className="cartImages"
          alt="Product" />
      </div>
      <div className="cartCol">
        {title}
      </div>
      <div className="cartCol">
        ${price}
      </div>
      <div className="cartCol">
        <div className="quantityButtons">
          <span id="decrementBtn" onClick={() => decrement(id)}>-</span>
          <span id="currentCount">{count}</span>
          <span id="incrementBtn" onClick={() => increment(id)}>+</span>
        </div>
      </div>
      {/*  */}
      <div className="cartCol">
        <div className="removeItem">
          <button onClick={()=>removeItem(id)}>Remove</button>
        </div>
      </div>
      <div className="cartCol">
        <strong>${total}</strong>
      </div>
    </div>
  )
}
